/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_EditInputs */

const vi_care_log_edit = /** @type {(inputs: Care_Log_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa nhật ký`)
};

/**

* @param {Care_Log_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_edit = /** @type {((inputs?: Care_Log_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_edit(inputs)
});